<script lang="ts">
  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  // stores
  import { InvoiceStore } from "@retailer/stores/InvoiceStore";
  import { creditsStore } from "@retailer/stores/CreditsStore";

  // data
  const pillClass = {
    available: "fizz-pill-gray",
    closed: "fizz-pill-black",
    applied: "fizz-pill-green",
    pending: "fizz-pill-yellow",
    scheduled: "fizz-pill-yellow",
  };

  const getRedemptionStatusText = redemption => {
    const { status } = redemption.payment_transfer;
    switch (status) {
      case "succeeded":
        return "Applied to Invoice #" + redemption.payment_invoice.invoice_reference_id;
      case "pending":
        return "Pending for Invoice #" + redemption.payment_invoice.invoice_reference_id;
      case "scheduled":
        return "Scheduled for Invoice #" + redemption.payment_invoice.invoice_reference_id;
    }
  };

  // reactives
  $: dataFetched = $InvoiceStore.invoice && !!$creditsStore.loaded.redemptions;
  $: totalCreditRedeemed = dataFetched
    ? Object.values($creditsStore.redemptions).reduce(
        (partialSum, a) => partialSum + parseFloat(a.amount),
        0
      )
    : null;
  $: remainingCredit = dataFetched
    ? parseFloat($InvoiceStore.invoice.original_amount_due) + totalCreditRedeemed
    : null;
  $: creditStatus =
    dataFetched && $InvoiceStore.invoice?.credit_status
      ? $InvoiceStore.invoice.credit_status[0].toUpperCase() +
        $InvoiceStore.invoice.credit_status.substring(1)
      : null;

</script>

<h4 class="fizz-heading-4 fizz-inset-squish-24 fizz-border-bottom">
  Credits from {$InvoiceStore.invoice.distributor.name}
</h4>
<div class="fizz-inset-square-24">
  <div class="fizz-inset-square-8 fizz-text-medium fizz-text-center">
    <p data-testid="invoice-number" class="fizz-text-subdued fizz-text-small fizz-stack-4">
      {"Invoice #" + $InvoiceStore.invoice.invoice_reference_id}
    </p>
    <p data-testid="original-balance" class="fizz-heading-2 fizz-stack-4">
      <FormatMoney input={parseFloat($InvoiceStore.invoice.original_amount_due)} formatType={"5"} />
    </p>
  </div>
  <p class="fizz-stack-24 fizz-text-center">
    <span class={pillClass[$InvoiceStore.invoice.credit_status]}>{creditStatus}</span>
  </p>
  {#if $creditsStore.redemptions.length > 0}
    <div class="fizz-surface-gray fizz-inset-stretch-24">
      {#each $creditsStore.redemptions as redemption, i}
        <div class="fizz-flex-row fizz-full-width fizz-space-between">
          <UIRouterLink
            stateName={`layout.invoice_details`}
            params={{ invoiceId: redemption.payment_invoice.id }}
            classes={"fizz-text-medium"}
          >
            <p data-testid={"redemption-label-" + redemption.id}>
              {getRedemptionStatusText(redemption)}
            </p>
          </UIRouterLink>
          <p data-testid={"redemption-amount-" + i}>
            <FormatMoney input={redemption.amount} formatType={"5"} />
          </p>
        </div>
      {/each}
      <div class="fizz-flex-row fizz-full-width fizz-space-between">
        <p class="fizz-text-strong">Remaining Balance</p>
        <p data-testid="remaining-balance" class="fizz-text-strong">
          <FormatMoney input={remainingCredit} formatType={"5"} />
        </p>
      </div>
    </div>
  {/if}
</div>
